import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";


interface Props {
    scores: number[]
}


const FinalScorePopup = ({ scores }: Props) => {

    function getData() {
        const res: { x: string; value: number; }[] = [];
        scores.forEach((val, idx) => {
            res.push({
                x: `Ronde ${idx + 1}`,
                value: val
            })
        });
        return res;
    }

    return (
        <div>
            <ResponsiveContainer width={800} height={400}>
                <LineChart
                    width={400}
                    height={400}
                    data={getData()}
                    margin={{
                        top: 5,
                        right: 5,
                        left: 5,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="x" />
                    <YAxis dataKey="value" />
                    <Tooltip />
                    <Legend />
                    <Line name="Score" type="monotone" dataKey="value" stroke="#8884d8" activeDot={{ r: 8 }} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};


export default FinalScorePopup;